<template>
    <div class="hash-bar">
        <div class="hash-left">
            <em class="title">
                {{ title }}
            </em>
            <p class="hash-value">
                {{ hash }}
            </p>
        </div>
        <!-- 左右分界 --> 
        <ButtonCopy
            class="hash-right"
            :value="hash" 
        />
    </div>
</template>

<script setup lang="ts">

const props = defineProps({
    title: {
        type: String,
        default: '',
    },
    hash: {
        type: String,
        default: '',
    },
});


</script>

<style scoped lang="scss">
.hash-bar{
    display: flex;
    align-items: center;
    background-color: #090c1199;
    border: 1px solid var(--color_grey-60);
    display: flex;
    position: relative;
    transition: color .1s ease-in-out,border-color .1s ease-in-out;
    border-radius: 10px;
    height: 58px;
    padding: 7px 18px;
    &:hover{
        border-color: var(--color_blue);
    }
}


.hash-left{
    flex: 1 1 auto;
    overflow-y: hidden;
    .title{
        border: none;
        font-size: 14px;
        letter-spacing: -.28px;
        padding: 0;  
        color: #303B4A;
        display: block;
        font-weight: 600;
        line-height: 18px;
    }
    .hash-value{
        font-size: 14px;
        line-height: 22px;
        width: 100%;
        overflow-y: hidden;
        overflow-x: scroll;
        font-weight: 600;
        color: white;
        cursor: text;
    }
}

.hash-right{
    flex: 0 0 auto;
    width: 44px !important;
    height: 44px !important;
    text-align: center;
    background-color: var(--color_grey-60);
    border-color: transparent;
    color: var(--color_grey-20);
    border-radius: 5px;
    font-size: 14px;
    margin-left: 10px;
    margin-right: -12px;
    &:hover{
        opacity: 0.9;
    }
    &:active{
        opacity: 0.8;
    }
    &:deep(svg){
        width: 22px;
        height: 22px;
    }
}


</style>
